<template>
  <el-collapse v-model="activeCollapses" class="collapse-main-content" style="margin-top: 16px">
    <!-- <el-card style="margin-top: 16px">
    <div slot="header" class="title">
      <span>审批信息</span>
    </div> -->
    <el-collapse-item name="1">
      <template slot="title">
        <div class="collapse-title-pre">
          <span></span>
          审批信息
        </div>
      </template>
      <div class="collapse-content">
        <SiruiSearch
          ref="auditRef"
          labelWidth="80px"
          :query="auditInfoData"
          :columns="baseColumns"
          :rules="auditRules"
          :isQueryPanel="false"
        ></SiruiSearch>
      </div>
    </el-collapse-item>
  </el-collapse>
  <!-- </el-card> -->
</template>

<script>
  export default {
    name: 'auditInfo',
    data() {
      return {
        auditInfoData: {
          info: '通过',
        },
        activeCollapses: ['1'],
      };
    },
    computed: {
      baseColumns() {
        return [
          {
            name: '审批信息',
            prop: 'info',
            type: 'textarea',
            span: 24,
            maxlength: 50,
          },
        ];
      },
      auditRules() {
        return {
          info: [{ required: true, message: '请填写审批意见', trigger: 'blur' }],
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
</style>
